<template>
  <v-card class="ma-2" flat>
    <v-card>
      <v-row>
        <v-card-title class="primary--text mt-1">
          <v-btn
            @click="back"
            style="font-style: italic; font-family: Times New Roman"
            class="text-left primary--text ml-n5"
            text
          >
            <v-icon>mdi-reply</v-icon></v-btn
          >Request Cards
          <span
            v-if="this.$store.getters.get_getCustDetails.is_purchase == 0"
            style="
              font-style: italic;
              font-family: Times New Roman;
              font-size: 14px;
            "
            class="text-left font-weight: 20 primary--text ml-2"
            >(Click on "Order Now" to subscribe to a Glyd Cards package)</span
          >
          <span
            v-else
            style="
              font-style: italic;
              font-family: Times New Roman;
              font-size: 14px;
            "
            class="text-left primary--text ml-2"
            >(Click on "Order Now" to Purchase Glyd Cards package)</span
          >
        </v-card-title>
      </v-row>

      <!-- <v-card-subtitle class="ml-1 mt-n1"> Click on "Order Now" to subscribe to a
          Glyd package.</v-card-subtitle> -->

      <v-tabs v-model="tab" grow color="primary" class="mt-1">
        <v-tab v-for="tabname in tabnames" :key="tabname"
          >{{ tabname }}
          <v-badge
            v-if="
              cardcount != null &&
              cardcount != '0' &&
              cardcount != '' &&
              tabname == 'Status'
            "
            :content="cardcount"
            value="cardcount"
            color="gold"
            class="mt-3 ml-3"
          >
          </v-badge
        ></v-tab>
      </v-tabs>
    </v-card>

    <!-- <NonPersonalized v-if="tab == 1" /> -->
    <Personalized v-if="tab == 0" />
    <Status v-if="tab == 1" @backchild="getcountNotification" />
    <!-- <acknowledge ref="acknowledge" />

    <page ref="paymentGateway" :redirect="redirect" />-->
  </v-card>
</template>

<script>
import Personalized from "@/Views/users/PersonalizedCards.vue";
// import NonPersonalized from "@/Views/users/NonPersonalized.vue";
import Status from "@/Views/users/StatusCard.vue";
import { apiCall } from "@/Views/APICALL/APIcall.js";

export default {
  components: {
    // NonPersonalized,
    Personalized,
    Status,
  },
  data: () => ({
    // "Non-Personalized",
    tabnames: ["Personalized", "Status"],
    tab: 0,

    Individual: "",
    p50: "",
    varhtml: "",
    cardcount: "",
  }),
  computed: {
    cardcount() {
      return this.$store.getters.get_Requestcards;
    },
  },
  mounted() {
    // this.getcardreqstatus();
    this.getcountNotification();
  },
  methods: {
    back() {
      this.$router.push("/Dashboard");
    },
    async getcountNotification() {
      var inputData = {
        method_name: "ADMINCORP",
        page_no: 1,
        record_count: 0,
        page_size: null,
        app_code: "APORTAL",
        method_param: {
          action: "BADGES",
          module_type: 2,
          corp_id: this.$store.getters.get_corpid,
          logged_user_id: this.$store.getters.get_userid,
        },
      };

      var responseData = await apiCall(inputData);
      // console.log("responseData",this.cardcount)

      for (let i = 0; i < responseData.data.data.length; i++) {
        switch (responseData.data.data[i].module_code) {
          case "CARDFUNDS":
            this.corpcount = responseData.data.data[i].count;
            this.$store.commit("SET_FundCount", this.corpcount);
            break;
          case "EXMGMT1":
            this.expensecount1 = responseData.data.data[i].count;
            this.$store.commit("SET_ExpenseCount1", this.expensecount1);
            break;
          case "EXMGMT2":
            this.expensecount2 = responseData.data.data[i].count;
            this.$store.commit("SET_ExpenseCount2", this.expensecount2);
            break;
          case "EXRVRY":
            this.expenserecover = responseData.data.data[i].count;
            this.$store.commit("SET_ExpenseRecoverCount", this.expenserecover);
            // console.log("cardcount1",this.expenserecover)
            break;
          case "CARDS":
            this.cardcount = responseData.data.data[i].count;
            //  console.log("cardcount2",this.cardcount)
            // this.$store.commit("SET_Requestcards", this.cardcount);

            break;
        }
      }
    },
  },
};
</script>

<style>
.rmclasstitle {
  color: orangered;
  font-size: 45px;
}
.rmclasssubtitle {
  color: orange;
  font-size: 15px;
}
</style>
